// --------------------------------------------------------------
// Created On: 2024-11-20
// Author: Zachary Thomas
//
// Last Modified: 2024-11-20
// Modified By: Zachary Thomas
//
// Copyright 2024 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import Card from "../../../components/Card/Card";
import { DASHBOARD_PROMOTIONAL_IMAGE, DASHBOARD_PROMOTIONAL_PARAGRAPHS } from "../../../constants/miscellaneous";
import styles from "./DashboardPromoCard.module.scss";

// A card for displaying promotional information on the dashboard.
export default function DashboardPromoCard(): Component {
  return (
    <div className="row px-3 justify-content-center">
      <div className="col-lg-8">
        <Card title="Genuine Cornell Replacement Parts">
          <div className="row">
            <div className="col-12 col-xxl-4">
              <img className="w-100 h-100" src={DASHBOARD_PROMOTIONAL_IMAGE} alt="eCommerce Promotional Image" />
            </div>
            <div className="col-12 col-xxl-8 pt-3">
              {DASHBOARD_PROMOTIONAL_PARAGRAPHS.map((paragraph, i) => (
                <p className={`${styles.promotionalParagraph} p-2`} key={i}>
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
